
Number.prototype.thousandsSeperator = function (): string {
    return Number( this ).toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
};

Number.prototype.toPesos = function (): string {
    return '$ ' + Intl.NumberFormat( 'de-DE' ).format( Number( this ).round( 2 ) );
};

Number.prototype.round = function ( n: number = 0 ): number {
    return Number( this.toFixed( n ) );
};

Number.prototype.isNan = function (): boolean {
    return isNaN( Number( this ) );
};
